import {Environment} from '../../reducers/environmentReducer';
import {type LoadingMode} from '../../models/IEnvironment';
import {PaymentConfiguration} from '../../reducers/paymentConfigurationReducer';
import {store} from '../../store';
import {Carts} from '../../reducers/cartReducer';
import {$qsAll} from '../../../../@shared/ts/dom';

export function setupAmazonPayButton() {
	store.subscribe(() => {
		renderAmazonPayButtonDisplay(
			PaymentConfiguration.selectedGateway(),
			Environment.modalUI.loadingMode(),
			Carts.total(),
			Carts.subscriptionPresent(),
		);
	});
}

function renderAmazonPayButtonDisplay(gatewayId: string, loadingMode: LoadingMode, allCartsTotal: number, hasSubscription: boolean) {
	// Currently our amazon pay integration lacks subscriptions support, don't render button if hasSubscription
	if (gatewayId.includes('peachpay_amazonpay') && loadingMode === 'finished' && !hasSubscription && allCartsTotal > 0) {
		$qsAll('.amazon-pay-payment-container').forEach(element => {
			element.classList.remove('hide');
		});
	} else {
		$qsAll('.amazon-pay-payment-container').forEach(element => {
			element.classList.add('hide');
		});
	}
}
